define("shared/components/shared/pre-boarding/survey-components/text-input", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--formWrapper tUG--questionCard__form" {{scroll-to-bottom "#self-describes-content"}}>
    <label for="">{{@otherInputLabel}}</label>
    <input
      class="o--form__input--lg tUG--questionCard__input{{@question.class}}
        {{if @hasInputError 'o--form__input--hasError'}}"
      data-test-survey="text-input"
      id={{@question.identifier}}
      placeholder={{@question.placeholder}}
      type="text"
      {{on "input" @inputTextFieldResponse}}
    />
    {{#if @hasInputError}}
      <p class="u--text--danger u--m__tb__xs" data-test-survey="error-paragraph">
        {{svg-jar "warning" class="o--icon u--m__r__xs"}}
        {{t "onboarding.self_describes.best_describes.options.other_input_error"}}
      </p>
    {{/if}}
  </div>
  */
  {
    "id": "ZK2K3P60",
    "block": "[[[11,0],[24,0,\"o--formWrapper tUG--questionCard__form\"],[4,[38,0],[\"#self-describes-content\"],null],[12],[1,\"\\n  \"],[10,\"label\"],[14,\"for\",\"\"],[12],[1,[30,1]],[13],[1,\"\\n  \"],[11,\"input\"],[16,0,[29,[\"o--form__input--lg tUG--questionCard__input\",[30,2,[\"class\"]],\"\\n      \",[52,[30,3],\"o--form__input--hasError\"]]]],[24,\"data-test-survey\",\"text-input\"],[16,1,[30,2,[\"identifier\"]]],[16,\"placeholder\",[30,2,[\"placeholder\"]]],[24,4,\"text\"],[4,[38,2],[\"input\",[30,4]],null],[12],[13],[1,\"\\n\"],[41,[30,3],[[[1,\"    \"],[10,2],[14,0,\"u--text--danger u--m__tb__xs\"],[14,\"data-test-survey\",\"error-paragraph\"],[12],[1,\"\\n      \"],[1,[28,[35,3],[\"warning\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n      \"],[1,[28,[35,4],[\"onboarding.self_describes.best_describes.options.other_input_error\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13]],[\"@otherInputLabel\",\"@question\",\"@hasInputError\",\"@inputTextFieldResponse\"],false,[\"scroll-to-bottom\",\"if\",\"on\",\"svg-jar\",\"t\"]]",
    "moduleName": "shared/components/shared/pre-boarding/survey-components/text-input.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});